module.exports = __webpack_public_path__ + "static/media/menu_advertisement_hoverActive.ea6acfd1.svg";